import { render, staticRenderFns } from "./user_tag_single_select.vue?vue&type=template&id=5e5d23da"
import script from "./user_tag_single_select.vue?vue&type=script&lang=js"
export * from "./user_tag_single_select.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./user_tag_single_select.vue?vue&type=style&index=1&id=5e5d23da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports